export default "__VITE_ASSET__ba37b2a0__"